export default "__VITE_ASSET__2435b996__"